import {
  ConfluenceEmbedAriResourceOwner,
  ConfluenceEmbedAriResourceType
} from "./chunk-N5UKNFK5.mjs";
import {
  RegisteredAri
} from "./chunk-AB4PPISI.mjs";
import {
  AriParser
} from "./chunk-S7RIZVFI.mjs";

// src/confluence/embed/manifest.ts
var confluenceEmbedAriStaticOpts = {
  qualifier: "ari",
  platformQualifier: "cloud",
  cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
  // eslint-disable-line no-useless-escape
  resourceOwner: ConfluenceEmbedAriResourceOwner,
  resourceType: ConfluenceEmbedAriResourceType,
  resourceIdSlug: "activation/{activationId}/{embedId}",
  resourceIdSegmentFormats: {
    activationId: /[a-zA-Z0-9\-]+/,
    // eslint-disable-line no-useless-escape
    embedId: /[0-9]+/
    // eslint-disable-line no-useless-escape
  }
};

// src/confluence/embed/index.ts
var ConfluenceEmbedAri = class _ConfluenceEmbedAri extends RegisteredAri {
  constructor(opts) {
    super(opts);
    this._siteId = opts.cloudId || "", this._activationId = opts.resourceIdSegmentValues.activationId, this._embedId = opts.resourceIdSegmentValues.embedId;
  }
  get siteId() {
    return this._siteId;
  }
  get activationId() {
    return this._activationId;
  }
  get embedId() {
    return this._embedId;
  }
  static create(opts) {
    let derivedOpts = {
      qualifier: confluenceEmbedAriStaticOpts.qualifier,
      platformQualifier: confluenceEmbedAriStaticOpts.platformQualifier,
      cloudId: opts.siteId,
      resourceOwner: confluenceEmbedAriStaticOpts.resourceOwner,
      resourceType: confluenceEmbedAriStaticOpts.resourceType,
      resourceId: `activation/${opts.activationId}/${opts.embedId}`,
      resourceIdSegmentValues: {
        activationId: opts.activationId,
        embedId: opts.embedId
      }
    }, ariOpts = AriParser.fromOpts(derivedOpts, confluenceEmbedAriStaticOpts);
    return new _ConfluenceEmbedAri(ariOpts);
  }
  static parse(maybeAri) {
    let opts = AriParser.fromString(maybeAri, confluenceEmbedAriStaticOpts);
    return new _ConfluenceEmbedAri(opts);
  }
  getVariables() {
    return {
      siteId: this.siteId,
      activationId: this.activationId,
      embedId: this.embedId
    };
  }
};

export {
  ConfluenceEmbedAri
};
